import { render, staticRenderFns } from "./dashboard_frequent_groups.vue.js?vue&type=template&id=16d126e3&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard_frequent_groups.vue?vue&type=template&id=16d126e3&vue3"
import script from "./dashboard_frequent_groups.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard_frequent_groups.vue?vue&type=script&lang=js&vue3"
export * from "./dashboard_frequent_groups.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard_frequent_groups.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports